/**
 * Reveal ao rolar do storytelling premium (pdp-story).
 * Progressivo: sem JS ou com prefers-reduced-motion, tudo fica visível
 * (a classe reveal-armed nunca é aplicada). Vanilla, idempotente.
 */
(function () {
  'use strict';

  if (window.__pdpStoryReveal) return;
  window.__pdpStoryReveal = true;

  var init = function () {
    var root = document.querySelector('.pdp-story');
    if (!root) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.classList.add('reveal-armed');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
